import {LitElement, html} from 'lit-element';
import getRequestAsPromise from '@twebcomponents/web-components-common/js/xhttp/getRequestAsPromise.js';
import TranslationManager from '@twebcomponents/web-components-common/js/utilities/translationManager.js';

class GroupPicker extends LitElement {
  
  render() {
    return html`<div class="filter-type">
      <div style="display:none">
      {{COMPONENT_CSS}}
      </div>
      <div id="defaultStyles"></div>
      <div id="customStylesFromUrl"></div>      
      <div id="customStyles"></div>      
      
      ${this.stylesLoaded?html`
      <div class="select-menu dropdown-pane-container ${this.isShowGroupList?'active':''}">
														<div class="name dropdownpane-link" @click="${this.showGroupList}">
															<div>
																<div>${this.tm.translate("Label")}</div>
															</div>
															<div>
                                ${this.getBadgeTemplate()}
																<i class="icon-font tc-icon-arrow-drop-down"></i>
															</div>
														</div>
														<div class="dropdown-pane ${this.isShowGroupList?'is-open':''} dropdown" id="groups-dropdown-pane-wrapper">
															<header>
																<div class="input-button-group search ${this.isShowSuggestionList?'is-active':''} dropdown-pane-container">
																		<button class="button tertiary icon-medium icon-circle">
																				<i class="icon-font tc-icon-search"></i>
																		</button>       
																		<input type="text" id="txt_search" placeholder="${this.tm.translate("SearchPlaceHolder")}" @keyup="${this.showSuggestionList}" .value="${this.groupSearchText}">     
																		<div class="line"></div>
																		  ${(this.showResultsPanel) ? html`<div class="auto-complete">
                                      ${this.suggestionList.length?html`
                                      <ul>
                                        ${this.suggestionList.map((item,i) => this.getSuggestedGroupTemplate(item))}
                                      </ul>`:html`${this.showResults ? html`<div class="info">
                                      ${this.tm.translate("NoResults")}
                                    </div>`: ''}`}
																			<!--<div class="info">
																				Too many results to display. Please refine your search.
																			</div>-->
																			<footer class="pr-1">
																					<span class="sub-text">
																						<span>${this.tm.translate("LastUpdated")}</span>: ${this.getLastUpdatedDateTime()}
                                          </span>
                                          ${this.loading ? html`
                                          <div class="align-center"><i class="icon-font tc-icon-spinner-dark"></i></div>`:html`
                                          <button class="button icon-medium icon-circle tertiary" @click="${(e) => {this.loadGroups(true, e);e.stopPropagation();}}">
                                          <i class="icon-font tc-icon-refresh"></i>
                                          </button>`}
																			</footer>
																		</div>` : ''}
																		${this.groupSearchText != '' ? html`<button class="button tertiary icon-medium icon-circle" @click="${this.clearSuggestionList}">
																			<i class="icon-font tc-icon-content-close"></i>
																		</button>` : ''}                                           
																</div>   
															</header>
															<hr/>
															<section>
                                ${this.groupList.length ? html`
                                <ul>
                                  ${this.groupList.map((item, i) => this.getGroupTemplate(item))}
                                </ul>`: html`
                                <div class="info">
                                  ${this.tm.translate("NoResults")}
                                </div>`}                                                                        
																<footer class="pr-1">
																	<span class="sub-text">
                                  <span>${this.tm.translate("LastUpdated")}</span>: ${this.getLastUpdatedDateTime()}                                 
                                  </span>
                                  ${this.loading ? html`
                                  <div class="align-center"><i class="icon-font tc-icon-spinner-dark"></i></div>`:html`
                                  <button class="button icon-medium icon-circle tertiary" @click="${(e) => {this.loadGroups(true, e);e.stopPropagation();}}">
                                  <i class="icon-font tc-icon-refresh"></i>
                                  </button>
                                  `}
																</footer>
															</section>
														</div>
														<div class="line"></div>
                          </div>
                          `:html`<div><i class="icon-font tc-icon-spinner-dark"></i></div>`}
                          </div> 
      `;
  }

  getGroupTemplate(item){
    return html`<li  @click="${(e) => this.updateSelectionList(e, item)}">
    <div class="select-menu-item multiple-line">
      <div class="icon checkbox">
          <input class="custom-input" name="filter" type="checkbox" id="${'u_' + item.id}" .checked="${this.isSelected(item)}"/>
          <label></label>                                                                 
      </div>                                                                                    
      <div>
          <label>${this.getName(item)}</label> 
          <span class="sub-text">${item.usersCount == null || item.usersCount == undefined?'0 ' + this.tm.translate("Users"):item.usersCount + ' ' + this.tm.translate("Users")}</span>
      </div>                                                                                                                                                                                                                                            
  </div>  
  </li>`
  }

  getSuggestedGroupTemplate(item){
    return html`<li> 
    <div class="select-menu-item multiple-line" @click="${(e) => this.updateSelectionList(e, item)}">                                                                                                                                                                     
      <div>
          <label>${this.getName(item)}</label> 
          <span class="sub-text">${item.usersCount == null || item.usersCount == undefined?'0 ' + this.tm.translate("Users"):item.usersCount + ' ' + this.tm.translate("Users")}</span>
      </div>                                                                                                                                                                                                                                            
    </div>
   </li>`
  }

  getBadgeTemplate(){
    return html`${this.selectionList && this.selectionList.length > 0 ? html`
    <span class="badge pill primary">${this.selectionList.length > 99 ? '99+' : this.selectionList.length} </span>`
    : ''}`
  }

  static get properties() {
    return {
      /* accessToken: Bearer token being passed in the api call (get group list) */
      accessToken: {
        type: String,
        attribute: 'access-token',
        reflect: false
      },
      /* apiUrl: Api url for fetching group list */
      apiUrl: {
        type: String,
        attribute: 'api-url',
        reflect: false
      },
      /* refreshDataCache: By default, the component will show groups from cache (localStorage) if exist and fetch from api if the group list is not avaialble in cache. Add this attribute in case, you want to force the api call for the initial loading of group list */
      refreshDataCache: {
        type: Boolean,
        attribute: 'refresh-data-cache',
        reflect: false
      },
      /* translationSource: To provide an array of translation sources. Each item in the list can either be a translation url or a translation dictionary. For example, the translation source can be defined as below.
      var translationUrl = "translations.json";

      var translationDictionary = {
      "componentTitle1": "Object picker",
      "launchButtonText": "Select",
      "browseDevice": "Browse device photos",
      "submit1": "Select"
      };


      var translationSource = [
        {
            "type": "URL",
            "value": translationUrl
        },
        {
            "type": "DICTIONARY",
            "value": translationDictionary
        }
      ];
      */
      translationSource: {
        type: Object,
        attribute: "translation-source",
        reflect: false
      },
      /* translationKeyMap: To provide translation 'custom translation key' - 'default translation key' mapping. This is useful when the component's translation key is different from the one mentioned in the cutome translation key */
      translationKeyMap: {
        type: Object,
        attribute: "translation-key-map",
        reflect: false
      },
      /* customStyleUrl: To provide custom stylesheet url */
      customStyleUrl: { 
        type: String,
        attribute: "custom-style-url",
        reflect: false
      },
      /* customStyle: To provide custom style */
      customStyle: { 
        type: String,
        attribute: "custom-style",
        reflect: false
      },
      /* selectionList: This is used to provide default selection when the components loads. This attribute also reflects the realtime selctions made in the component. So, the consumer application can use this if required */
      selectionList: {
        type: Array,
        attribute: "selection-list",
        reflect: true
      }
    };
  }

  constructor(defaultAttributes) {
    super();
    console.log("api url:", this.apiUrl);
    this.componentName = 'group-picker';
    this.apiUrl = "";
    this.accessToken = "";
    
    this.suggestionList = [];
    this.groupList = [];
    this.selectionList = [];
    this.translationSource = [];
    this.translationKeyMap = {};
    this.customStyle = '';
    this.customStyleUrl = '';

    this.loading = false;
    this.pageSize = 25;
    this.showResults = false;
    this.showResultsPanel = false;

    this.isShowSuggestionList = false;
    this.isShowGroupList = false;
    this.defaultTranslationDictionary = {
      Label : "Group",
      SearchPlaceHolder : "Search groups",
      LastUpdated : "Last updated",
      NoResults : "No groups found",
      Users: "users"
    };
    this.stylesLoaded = false;
    this.groupSearchText = '';

    this.tm = new TranslationManager(null, null, this.defaultTranslationDictionary);

    defaultAttributes = defaultAttributes || {};
    Object.keys(defaultAttributes).forEach(function(attrKey){
      if( defaultAttributes[attrKey] != null ) {
        this.setAttribute(attrKey, defaultAttributes[attrKey]);
      }
    }.bind(this));
  }
  
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("on-window-resize", function(e){
      this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail: {}}));
    }.bind(this));
    this.dispatchEvent(new CustomEvent('on-component-ready', {detail: {source: "group-picker"}}));

    this.getStyles();

    this.getCustomStyles();

    if(window.document.addEventListener)
      
      window.document.addEventListener("click", (evt) => this.documentClick(evt, this), false);
    else
      window.document.attachEvent("onclick", this.documentClick).bind(this);

    this.addEventListener("on-check-collapse", function(e){
      this.checkCollapse(e);
    }.bind(this));      
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(newValue && newValue != 'null' && newValue.indexOf('{{') == -1){
      this.accessToken = (name == 'access-token')? newValue : this.accessToken;
      this.apiUrl = (name == 'api-url')? newValue : this.apiUrl;

      this.translationSource = (name == 'translation-source')? (newValue ? this.parseJSON(newValue, []) : []) : this.translationSource;
      this.translationKeyMap = (name == 'translation-key-map')? (this.isNonEmptyObject(this.parseJSON(newValue, {})) ? this.parseJSON(newValue, {}) : {}) : this.translationKeyMap;

      this.selectionList = (name == 'selection-list')? (newValue ? this.parseJSON(newValue, []) : []) : this.selectionList;
      this.refreshDataCache = (name == 'refresh-data-cache')? newValue : this.refreshDataCache;
      this.customStyleUrl = (name == 'custom-style-url')? newValue : this.customStyleUrl;
      this.customStyle = (name == 'custom-style')? newValue : this.customStyle;

      if( (name == 'api-url' || name == 'access-token' || name == "refresh-data-cache") && this.accessToken && this.apiUrl){
        if(!this.loading){
          if(this.refreshDataCache)
            this.loadGroups(true);
          else
            this.loadGroups(false);
        }
      } 

      if(name == "translation-source"){
        this.tm.setTranslationSource(this.translationSource);
      }
      if(name == "translation-key-map"){
        this.tm.setTranslationKeyMap(this.translationKeyMap);
      }

      if(name == 'selection-list'){
        this.dispatchEvent(new CustomEvent('selection-changed', {detail: {source: "group-picker", data: this.selectionList}}));
      }

      this.requestUpdate();
    }
  }

  parseJSON(value, defaultValueOnParseFailure){
    var result = null;
    if (typeof value === "object") {
      result = value;
    } else {
      try {
        result = JSON.parse(value);
      }
      catch (err) {
        if(defaultValueOnParseFailure){
          result = defaultValueOnParseFailure;
        }else{
          throw err;
        }
      }
    }

    return result;
  }

  loadGroups(clearCache){
    if(this.loading){
      console.log("previous grouplist call is still in progress");
      return;
    }
    //this.loading = true;
    this.groupList = [];

    if(clearCache){
      this.groupCache = [];
    }
    var projectGroupData = this.groupCache;

    // return the cached groups list immediately to avoid delay to the user - UX decision
    if(projectGroupData && projectGroupData.groups && projectGroupData.groups.length && projectGroupData.key == this.apiUrl.toLowerCase()){
      console.log("resolving with data from cache = ", projectGroupData.groups);
      this.groupList = projectGroupData.groups;
      this.loading = false;
      this.cleanSelectionList();
      this.requestUpdate('loading');
      this.requestUpdate('groupList');
    }else{
      this.groupCache = [];

      var startIndex = !this.groupList.length ? 0 : this.groupList.length;
      var endIndex = startIndex + this.pageSize;
      this.loading = true;    
      this.requestUpdate('loading');
      this.getList(this.apiUrl, this.accessToken, startIndex, endIndex).then(
        (res) => this.processGroupResults(res),
        (err) => {
          console.log("error in fetching group list", err);
          this.loading = false;
          this.requestUpdate();
        }
      );
    }
  }
  
  processGroupResults(result) {
    var self = this;
    //this.loading = false;
    var groupsTemp = JSON.parse(result.response);

    //display the available group list instead of waiting for the entire list to arrive
    self.groupCache = groupsTemp;
    self.groupList = self.groupCache.groups;
    console.log("first call self.groupList = ", self.groupList);
    self.requestUpdate('groupList');

    var contentRange = result.getResponseHeader("content-range");
    var totalRecords = parseInt(contentRange.substring(contentRange.indexOf("/") + 1));
    var rangeEnd = parseInt(contentRange.split("/")[0].split("-")[1]);

    //Make additional calls if more groups exist
    if (groupsTemp.length < totalRecords) {
      console.log("inside length check groupsTemp.length = ", groupsTemp.length);
      console.log("inside length check totalRecords = ", totalRecords);
      var groupApiCalls = [];
      for (var i = rangeEnd + 1; i < totalRecords; i += this.pageSize) {
        let start = i, end = i + this.pageSize - 1;
        groupApiCalls.push(this.getList(this.apiUrl, this.accessToken, start, end));
      }

      console.log("groupApiCalls = ", groupApiCalls);
      if (groupApiCalls.length) {
        Promise.all(groupApiCalls).then(function (groupArrays) {
          self.loading = false;
          console.log("all group api calls success = ", groupArrays);
          groupArrays = groupArrays.map((u) => JSON.parse(u.response));
          groupArrays = Array.prototype.concat.apply([], groupArrays);
          groupsTemp = groupsTemp.concat(groupArrays);
          groupsTemp = groupsTemp.sort((g1, g2) => self.getName(g1).localeCompare(self.getName(g2)));
          self.groupCache = groupsTemp;
          self.groupList = self.groupCache.groups;
          console.log("self.groupList = ", self.groupList);
          this.cleanSelectionList();
          self.requestUpdate('loading');
          self.requestUpdate('groupList');
        }, function (err) {
          console.log("error fetching groups list", err);
          self.loading = false;
        });
      } else {
        self.loading = false;
        this.groupCache = groupsTemp;
        this.groupList = this.groupCache.groups;
        this.cleanSelectionList();
        this.requestUpdate('groupList');
      }
    } else {
      self.loading = false;
      console.log("all the groups are available in the first call itself = ", groupsTemp);
      this.groupCache = groupsTemp;
      this.groupList = this.groupCache.groups;
      this.cleanSelectionList();
      this.requestUpdate('groupList');
    }
  }

  get groupCache(){
    return JSON.parse(localStorage.getItem("gp_groups_list"));
  }

  set groupCache(groupList){
    var projectGroupData = {
      key: this.apiUrl.toLowerCase(),
      groups: groupList,
      //lastModifiedTimeStamp: (new Date(0)).getTime(),
      cacheDateTime: Date.now()
    }
    localStorage.setItem("gp_groups_list", JSON.stringify(projectGroupData));    
  }

  getLastUpdatedDateTime(){
    var result = '';
    if(this.groupCache && this.groupCache.cacheDateTime > (new Date(0)).getTime()){
      result = (new Date(this.groupCache.cacheDateTime)).toUTCString();
    }
    return result;
  }

  updateSelectionList(e, item){
    e.stopPropagation();
    console.log("updateSelectionList id = ", item.id);
    var id = '';
    if(item && item.id){
      id = item.id;
    }else{
      id = item;
    }

    if(id){
      if(this.selectionList.indexOf(id) > -1){
        this.selectionList.splice(this.selectionList.indexOf(id), 1);
      }else{
        this.selectionList.push(id);
      }
      this.requestUpdate('selectionList');
      this.dispatchEvent(new CustomEvent('group-selected', {detail: {source: "group-picker", data: this.selectionList}}));
      this.hideSuggestionsPanel();
    }
  }

  isSelected(item){
    var id = '';
    if(item && item.id){
      id = item.id;
    }else{
      id = item;
    }

    return id && (this.selectionList.indexOf(id) > -1);
  }

  isNonEmptyObject(obj){
    //console.log("obj=", obj);
    var result = false;
    try{
      obj = typeof obj == "object" ? obj : JSON.parse(obj);
      result = Object.keys(obj).length > 0;
    }catch(err){
      result = false;
      console.log("error in isNonEmptyObject check", err);
    }

    //console.log("isNonEmptyObject = ", result);
    return result;
  }
  
  firstUpdated(changedProps) {
    super.update(changedProps);
  }

  getList(apiUrl, accessToken, startIndex, endIndex){
    startIndex = startIndex || 0;
    endIndex = endIndex || startIndex + this.pageSize - 1;
    var headers = {
      "Content-type": "application/json",
      "Authorization": "Bearer " + (this.accessToken || accessToken),
      "Range": "items=" + startIndex +"-" + endIndex,
      "X-Range": "items=" + startIndex +"-" + endIndex
    };
    var promise = getRequestAsPromise("GET", apiUrl, headers, true);
    return promise;
  }

  updated(changedProps){
    super.updated(changedProps);
  }

  getName(item){
    return item && item.name ? item.name : "";
  }

  showSuggestionList(e){
    e.stopPropagation();
    this.showResultsPanel = false;
    //console.log("e=",e);
    if(e.key == "Escape"){
      this.isShowSuggestionList = false;
      //e.preventDefault();
    }else{
      this.showResultsPanel = true;
      this.isShowSuggestionList = true;
      this.suggestionList = [];
      var query = this.shadowRoot.querySelector("#txt_search");
      //console.log("query = ", query);
      if(query){
        //console.log("query value = ", query.value);
        //console.log("item=", item);
        var results = [];
        if(this.groupList.length){
          results = this.groupList.filter(u => (u.name && u.name.toLowerCase().indexOf(query.value.toLowerCase()) > -1));
        }

        //exclude already selected groups form suggestionList
        results = results.filter(u => !(this.isSelected(u.id)) );
        this.suggestionList = results;

        if(!query.value){
          this.isShowSuggestionList = false;
          this.showResultsPanel = false;
        }
        this.showResults = true;
        this.groupSearchText = query.value;
      }

      //console.log(this.suggestionList);
    }
    this.requestUpdate('suggestionList');
  }

  clearSuggestionList(e){
    e.stopPropagation();
    var query = this.shadowRoot.querySelector("#txt_search");
    if(query && query.value){
      query.value = "";
    }
    this.groupSearchText = '';''
    this.isShowSuggestionList = false;
    this.suggestionList = [];
    this.showResultsPanel = false;
    this.showResults = false;
    this.requestUpdate('suggestionList');
  }

  cleanSelectionList(){ //Remove deleted items. For example, if the source list doesn't have an item, it cannot be selected. So, such items should be removed from SelectionList
    //TBD
  }  
  
  showGroupList(e){
    //e.stopPropagation();
    //console.log("inside showGroupList");
    if(e.key == "Escape"){
      this.isShowGroupList = false;
      this.isShowSuggestionList = false;
      this.clearSearchBox();
      //e.preventDefault();
    }else{
      this.isShowGroupList = !this.isShowGroupList;
      //console.log(this.isShowGroupList);
      if(!this.isShowGroupList){
        this.isShowSuggestionList = false;
        this.clearSearchBox();
      }
      let dropDownContainer = this.shadowRoot.getElementById('groups-dropdown-pane-wrapper');
      if(dropDownContainer){
        setTimeout(() => dropDownContainer.scrollTop = 0, 0);        
      }
      this.requestUpdate('groupList');
    }
  }

  documentClick(e){
    //console.log("target1 = ", e.target);
    this.dispatchEvent(new CustomEvent('on-check-collapse', {detail: {from:e.target.id}}));
  }

  checkCollapse(e){
    //console.log("target = ", e.target);
    if(e.detail.from !== this.id){
      //console.log("hide");
      this.isShowGroupList = false;
      this.isShowSuggestionList = false;
      this.showResultsPanel = false;
      this.showResults = false;
      this.clearSearchBox();
      this.requestUpdate('groupList');
    }
  }
  hideSuggestionsPanel(){
    this.isShowSuggestionList = false;
    this.showResultsPanel = false;
    this.showResults = false;
    this.clearSearchBox();
    this.requestUpdate('groupList');
  }
  clearSearchBox(){
    var query = this.shadowRoot.querySelector("#txt_search");
    if(query){
      query.value = '';
    }
    this.groupSearchText = '';
  }

  async getStyles(){
    var resultIconStyle = "";

    resultIconStyle = await getRequestAsPromise("GET", "{{RESOURCE_DOMAIN}}/fonts/icon-font.min.css", null);
    var nodeIcons = document.createElement('style');
    nodeIcons.innerHTML = resultIconStyle;
    this.shadowRoot.querySelector("#defaultStyles").appendChild(nodeIcons);

    var nodeFontStyle = document.createElement('style');
    nodeFontStyle.innerHTML = `@font-face {
      font-family: 'tcw_svg';
      src: url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.eot");
      src: url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.eot#iefix") format("embedded-opentype"), url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.ttf") format("truetype"), url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.woff") format("woff"), url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.svg#tcw_svg") format("svg");
      font-weight: normal;
      font-style: normal; 
    }	`;
    window.document.head.appendChild(nodeFontStyle);

    this.stylesLoaded = true;
    this.requestUpdate();
  }

  async getCustomStyles(){
    if(this.customStyleUrl){
      var result = "";
      var customStylesFromUrlNode = document.createElement('style');
      result = await Xhttp.getStylesAsString(this.customStyleUrl);
      customStylesFromUrlNode.innerHTML = result;
      this.shadowRoot.querySelector("#customStylesFromUrl").appendChild(customStylesFromUrlNode);
      this.requestUpdate();
    }
    
    if(this.customStyle){
      var customStylesNode = document.createElement('style');
      customStylesNode.innerHTML = this.customStyle;
      this.shadowRoot.querySelector("#customStyles").appendChild(customStylesNode);
      this.requestUpdate();
    }
  }
}

console.log("is group-picker already registered = ", !!customElements.get('group-picker'));
if(!customElements.get('group-picker')){
  customElements.define('group-picker', GroupPicker);
  console.log("is group-picker successfully registered = ", !!customElements.get('group-picker'));
}

export default GroupPicker;
window.GroupPicker= GroupPicker;